/* VCTparts: the live parts of the cart drawer and the cart page.
   Xtra re-renders the drawer (and the cart page) with fresh HTML after every
   change, and inline scripts in that HTML do not run, so everything here is
   idempotent and runs again whenever that content changes.
   - Dispatch promise: "Vandaag verzonden als je binnen 2 u 13 min bestelt",
     from the visitor's clock (same cut-off as the product page: 20:00 on
     weekdays). Only rendered when every line ships from stock
     (snippets/vct-cart-goal.liquid).
   - Free-shipping bar: grows from its previous width, and marks the moment
     free shipping is unlocked once.
   - 'Maak je bestelling compleet': leaves out products already in the cart,
     puts products that complete free shipping first (with a badge) and
     keeps the row short.
   - Feedback Company score in the drawer, from the same cached summary as
     snippets/vct-feedback-bar.liquid (the API key stays in the Worker). */
(function () {
  'use strict';

  var LANG = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
  var T = {
    nl: {
      today: '<strong>Vandaag verzonden</strong> als je binnen {t} bestelt',
      tomorrow: '<strong>Morgen verzonden</strong> als je nu bestelt',
      monday: '<strong>Maandag verzonden</strong> als je nu bestelt',
      h: 'u', m: 'min', free: '+ gratis verzending'
    },
    de: {
      today: '<strong>Heute versandt</strong>, wenn du innerhalb von {t} bestellst',
      tomorrow: '<strong>Morgen versandt</strong>, wenn du jetzt bestellst',
      monday: '<strong>Am Montag versandt</strong>, wenn du jetzt bestellst',
      h: 'Std.', m: 'Min.', free: '+ Gratis Versand'
    },
    fr: {
      today: '<strong>Expédié aujourd’hui</strong> si vous commandez dans les {t}',
      tomorrow: '<strong>Expédié demain</strong> si vous commandez maintenant',
      monday: '<strong>Expédié lundi</strong> si vous commandez maintenant',
      h: 'h', m: 'min', free: '+ livraison offerte'
    },
    en: {
      today: '<strong>Ships today</strong> if you order within {t}',
      tomorrow: '<strong>Ships tomorrow</strong> if you order now',
      monday: '<strong>Ships Monday</strong> if you order now',
      h: 'h', m: 'min', free: '+ free shipping'
    }
  };
  var CUTOFF_HOUR = 20;
  var UPSELL_MAX = 8;
  var FC_URL = 'https://vct-reviews.henkherrebout.workers.dev/reviews.json';
  var FC_CACHE = 'vct-fc-summary';

  function store(key, value) {
    try {
      if (value === undefined) return sessionStorage.getItem(key);
      sessionStorage.setItem(key, value);
    } catch (e) {}
    return null;
  }

  /* ---- Dispatch promise ------------------------------------------------ */

  function promiseHtml(t, now) {
    var day = now.getDay();
    var hour = now.getHours();
    if (day >= 1 && day <= 5 && hour < CUTOFF_HOUR) {
      var cutoff = new Date(now);
      cutoff.setHours(CUTOFF_HOUR, 0, 0, 0);
      var minutes = Math.max(1, Math.ceil((cutoff - now) / 60000));
      var h = Math.floor(minutes / 60);
      var m = minutes % 60;
      var left = h ? h + ' ' + t.h + (m ? ' ' + m + ' ' + t.m : '') : m + ' ' + t.m;
      return t.today.replace('{t}', left);
    }
    if (day >= 1 && day <= 4) return t.tomorrow;
    return t.monday;
  }

  function updatePromises() {
    var nodes = document.querySelectorAll('[data-vct-promise]');
    if (!nodes.length) return;
    var now = new Date();
    for (var i = 0; i < nodes.length; i++) {
      var t = T[nodes[i].getAttribute('data-vct-promise')] || T[LANG] || T.nl;
      var html = promiseHtml(t, now);
      if (nodes[i].getAttribute('data-vct-html') !== html) {
        nodes[i].innerHTML = html;
        nodes[i].setAttribute('data-vct-html', html);
      }
    }
  }

  /* ---- Free-shipping goal ---------------------------------------------- */

  function updateGoals() {
    var goals = document.querySelectorAll('.vct-goal[data-vct-goal]:not([data-vct-seen])');
    if (!goals.length) return;
    var prevPct = parseInt(store('vct-goal-pct'), 10);
    var wasReached = store('vct-goal-reached');
    var pct = null;
    var reached = false;
    for (var i = 0; i < goals.length; i++) {
      var goal = goals[i];
      goal.setAttribute('data-vct-seen', '');
      if (goal.getAttribute('data-vct-goal') === '') continue;
      pct = parseInt(goal.getAttribute('data-vct-goal'), 10) || 0;
      reached = goal.classList.contains('is-reached');
      if (reached) {
        if (wasReached === '0') goal.classList.add('is-unlocked');
        continue;
      }
      var fill = goal.querySelector('.vct-goal__fill');
      if (fill && !isNaN(prevPct) && prevPct !== pct && prevPct < 100) {
        fill.style.transition = 'none';
        fill.style.width = prevPct + '%';
        void fill.offsetWidth;
        fill.style.transition = '';
        fill.style.width = pct + '%';
      }
    }
    if (pct !== null) {
      store('vct-goal-pct', String(reached ? 100 : pct));
      store('vct-goal-reached', reached ? '1' : '0');
    }
  }

  /* ---- Recommendations ------------------------------------------------- */

  function updateUpsell() {
    var blocks = document.querySelectorAll('#cart .cart-upsell');
    if (!blocks.length) return;
    var cart = document.getElementById('cart');
    var inCart = {};
    var lines = cart.querySelectorAll('[data-vct-product-id]');
    for (var i = 0; i < lines.length; i++) inCart[lines[i].getAttribute('data-vct-product-id')] = true;
    var goal = cart.querySelector('[data-vct-left]');
    var left = goal ? parseInt(goal.getAttribute('data-vct-left'), 10) || 0 : 0;
    var t = T[LANG] || T.nl;

    for (var b = 0; b < blocks.length; b++) {
      var list = blocks[b].querySelector('.l4ca');
      if (!list) continue;
      var items = Array.prototype.slice.call(list.children).filter(function (li) {
        if (li.tagName !== 'LI') return false;
        if (inCart[li.getAttribute('data-product-id')] || li.querySelector('.overlay-unavailable-buy-button')) {
          li.parentNode.removeChild(li);
          return false;
        }
        return true;
      });

      var ordered = items;
      if (left > 0) {
        var closers = [];
        var rest = [];
        items.forEach(function (li) {
          var price = parseInt(li.getAttribute('data-price'), 10);
          (price >= left ? closers : rest).push(li);
        });
        closers.sort(function (a, c) {
          return parseInt(a.getAttribute('data-price'), 10) - parseInt(c.getAttribute('data-price'), 10);
        });
        ordered = closers.concat(rest);
        items.forEach(function (li) {
          var isCloser = closers.indexOf(li) > -1;
          var badge = li.querySelector('.vct-upsell-badge');
          if (isCloser && !badge) {
            badge = document.createElement('span');
            badge.className = 'vct-upsell-badge';
            badge.textContent = t.free;
            li.insertBefore(badge, li.firstChild);
          } else if (!isCloser && badge) {
            badge.parentNode.removeChild(badge);
          }
        });
      }

      var same = ordered.length === items.length && ordered.every(function (li, n) { return li === items[n]; });
      if (!same) ordered.forEach(function (li) { list.appendChild(li); });
      ordered.slice(UPSELL_MAX).forEach(function (li) { li.parentNode.removeChild(li); });
      blocks[b].style.display = list.children.length ? '' : 'none';
    }
  }

  /* ---- Feedback Company score in re-rendered HTML ---------------------- */

  var fcPending = null;

  function applyFc(bars, summary) {
    var score = summary && Number(summary.score);
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      if (!score) {
        bar.classList.add('is-fallback', 'is-loaded');
        continue;
      }
      var locale = bar.getAttribute('data-locale') || 'nl-NL';
      var count = Number(summary.count) || 0;
      bar.querySelector('[data-vct-fc-score]').textContent =
        score.toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + '/10';
      if (count) bar.querySelector('[data-vct-fc-count]').textContent = count.toLocaleString(locale);
      else bar.querySelector('.vct-fc__count').hidden = true;
      bar.querySelector('.vct-fc__stars-fill').style.width = Math.max(0, Math.min(100, score * 10)) + '%';
      bar.classList.add('is-loaded');
    }
  }

  function updateFc() {
    var bars = document.querySelectorAll('[data-vct-fc]:not([data-vct-fc-ready]):not(.is-loaded)');
    if (!bars.length) return;
    for (var i = 0; i < bars.length; i++) bars[i].setAttribute('data-vct-fc-ready', '');
    // Same source and cache as the review tab (layout/theme.liquid)
    if (window.vctFcSummary) {
      window.vctFcSummary().then(function (summary) { applyFc(bars, summary); }, function () { applyFc(bars, null); });
      return;
    }
    var cached = null;
    try { cached = JSON.parse(store(FC_CACHE) || 'null'); } catch (e) {}
    if (cached && cached.score) return applyFc(bars, cached);
    if (!fcPending) {
      fcPending = fetch(FC_URL, { credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var summary = data && data.summary;
          if (summary && summary.score) store(FC_CACHE, JSON.stringify({ score: summary.score, count: summary.count }));
          return summary;
        })
        .catch(function () { return null; });
    }
    fcPending.then(function (summary) { applyFc(bars, summary); });
  }

  /* ---- Wiring ---------------------------------------------------------- */

  var observer = null;
  var timer = null;

  function run() {
    timer = null;
    updatePromises();
    updateGoals();
    updateUpsell();
    updateFc();
    // Our own DOM changes are not a reason to run again
    if (observer) observer.takeRecords();
  }

  function schedule() {
    if (!timer) timer = setTimeout(run, 60);
  }

  function init() {
    run();
    setInterval(updatePromises, 30000);
    if (!('MutationObserver' in window)) return;
    observer = new MutationObserver(schedule);
    var cart = document.getElementById('cart');
    if (cart) observer.observe(cart, { childList: true, subtree: true });
    var page = document.querySelector('.form-cart');
    var section = page && page.closest('.shopify-section');
    if (section) observer.observe(section, { childList: true, subtree: true });
  }

  /* The chat (snippets/vct-chat.liquid) adds products itself and then fires
     "vct-chat:winkelwagen". Refresh the drawer and the count the way Xtra does
     after its own add, but keep the drawer closed: it would hide the chat
     in the middle of a conversation. */
  function refreshAfterChat() {
    if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
      try { window.ajaxCart.load(false, false, false, true); return; } catch (e) { /* then only the count */ }
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = document.getElementById('cart-count');
        if (count && cart && typeof cart.item_count === 'number') count.textContent = cart.item_count;
      })
      .catch(function () { /* the count catches up on the next page */ });
  }
  document.addEventListener('vct-chat:winkelwagen', refreshAfterChat);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
